import React, { useContext, useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';
import styles from './christmasSchedule.module.scss';
import { IconWrapper } from '../../common/IconWrapper';
import { faTree } from '@fortawesome/free-solid-svg-icons';
import AuthContext from '../../authentication/AuthContext';
import UserContext from '../../user/UserContext';
import axios from 'axios';
import Moment from 'react-moment';
import moment from 'moment';

export default function ChristmasSchedule() {
    let [schedules, setSchedules] = useState([]);

    const cas = useContext(AuthContext);

    const { userDetails } = useContext(UserContext);

    useEffect(() => {
        if (userDetails.currentFranchise) {
            axios
                .get(
                    window.CONFIG['ws.activoc-web-order-api.christmas.schedules'].replace(
                        '{franchiseCode}',
                        userDetails.currentFranchise.code
                    ),
                    {
                        headers: {
                            Authorization: cas,
                            'Content-Type': 'application/json'
                        }
                    }
                )
                .then(response => {
                    setSchedules(
                        response.data.map(schedule => (
                            <tr key={schedule.supplierCode + schedule.orderCutoff}>
                                <td>{mapToReadableSupplier(schedule.supplierCode)}</td>
                                <td>
                                    <Moment format={'dddd DD/MM/YYYY HH:mm'} date={schedule.orderCutoff} />
                                </td>
                                <td>
                                    <Moment format={'DD/MM/YYYY'} date={schedule.deliveryDay} />
                                </td>
                            </tr>
                        ))
                    );
                });
        }
    }, [cas, userDetails]);

    function mapToReadableSupplier(input) {
        switch (input) {
            case 'NISA':
                return 'Nisa Ambient';
            case 'NISAC':
                return 'Nisa Chill';
            default:
                return 'Nisa Freeze';
        }
    }

    return (
        <>
            <div className={'page-header'}>
                <div className={'content'}>
                    <div className={'page-header-container flex'}>
                        <h1>
                            <>My Christmas Delivery Schedule </>
                            <IconWrapper icon={faTree} />
                        </h1>
                    </div>
                </div>
            </div>

            <div className={'content'}>
                <h2>Today's Date: {moment().format('DD/MM/YYYY')}</h2>
                <Table className={styles.cutoffTable}>
                    <thead>
                        <tr>
                            <th>Supplier</th>
                            <th>Cutoff</th>
                            <th>Delivery Date</th>
                        </tr>
                    </thead>
                    <tbody>{schedules}</tbody>
                </Table>
            </div>
        </>
    );
}
